import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/trt20210034/Desktop/p-dsp/linqops/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/trt20210034/Desktop/p-dsp/linqops/node_modules/next/dist/client/image-component.js");
